import KnowledgeBaseSettingsRecord from '../records/KnowledgeBaseSettingsRecord';
import ThemeSettingsRecord from '../records/ThemeSettingsRecord';
import { NAV_ITEMS } from './TemplateEditorConstants';
const {
  CATEGORY_ID,
  CATEGORIES,
  CONTENT,
  FOOTER,
  HEADER,
  HEADER_BACKGROUND,
  NAV_BAR
} = NAV_ITEMS;
export const HIGHLIGHT_CLASSNAMES = {
  HOVERED_FIELD_HIGHLIGHT: 'preview_hovered-field-highlight',
  SELECTED_FIELD_HIGHLIGHT: 'preview_selected-field-highlight'
};
const PreviewSelectors = {
  SEARCH_SECTION: 'kb-search-section',
  SEARCH_TITLE: 'kb-search-title',
  INDEX_CATEGORIES_CONTAINER: 'kb-index-categories-container',
  INDEX_CATEGORY_PREFIX: 'kb-index__category-',
  HEADER: 'kb-header',
  FOOTER: 'kb-footer'
};
export const NAV_ITEM_TO_PREVIEW_SELECTOR = {
  [HEADER_BACKGROUND]: [PreviewSelectors.SEARCH_SECTION],
  [HEADER]: [PreviewSelectors.SEARCH_TITLE],
  [CATEGORIES]: [PreviewSelectors.INDEX_CATEGORIES_CONTAINER],
  [CATEGORY_ID]: [PreviewSelectors.INDEX_CATEGORY_PREFIX],
  [NAV_BAR]: [PreviewSelectors.HEADER],
  [FOOTER]: [PreviewSelectors.FOOTER]
};
export const PREVIEW_SELECTOR_TO_NAV_ITEM_PATH = {
  [PreviewSelectors.SEARCH_SECTION]: [CONTENT, HEADER, HEADER_BACKGROUND],
  [PreviewSelectors.SEARCH_TITLE]: [CONTENT, HEADER],
  [PreviewSelectors.INDEX_CATEGORIES_CONTAINER]: [CONTENT, CATEGORIES],
  [PreviewSelectors.INDEX_CATEGORY_PREFIX]: [CONTENT, CATEGORIES],
  [PreviewSelectors.HEADER]: [CONTENT, NAV_BAR],
  [PreviewSelectors.FOOTER]: [CONTENT, FOOTER]
};
export const POST_MESSAGE_TYPES = {
  PREVIEW_ELEMENT_CLICKED: 'PREVIEW_ELEMENT_CLICKED'
};
export const PREVIEW_SELECTOR_ATTRIBUTE_NAME = 'data-preview-id';
export const PREVIEW_SYNC_CONFIG = {
  homepageCategoriesSettings: {
    immutable: true
  },
  templateEditorNavigationContext: {
    immutable: true,
    parseAfterMessageReceived: templateEditorNavigationContext => {
      return templateEditorNavigationContext;
    }
  },
  templatePreviewPlaceholders: {
    immutable: false
  },
  templateSettings: {
    immutable: true,
    parseAfterMessageReceived: ({
      knowledgeBaseSettings,
      themeSettings
    }) => {
      // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
      return new ImmutableMap([['knowledgeBaseSettings', new KnowledgeBaseSettingsRecord(knowledgeBaseSettings)], ['themeSettings', new ThemeSettingsRecord(themeSettings)]]);
    }
  },
  theme: {
    immutable: false
  }
};
export const PREVIEW_SELECTORS = PreviewSelectors;